import React from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Button,
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Tooltip,
  Typography
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import { actionSendNotification } from "../../actions/UserActions"
import Util, {SUCCESS, ERROR} from "../../common/Util"
import ImageSelector from "../../components/ImageSelector/ImageSelector"
let _handleSubmitFail;

class NotifyUser extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={sendingNoty:false}
    this.onSend=this.onSend.bind(this)
    this.onClose=this.onClose.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)

  }
 
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSend(formValue){
    this.setState({sendingNoty:true})
    this.props.actionSendNotification(
      this.props.user,
      formValue, 
      ()=>{
        this.setState({sendingNoty:false})
        Util.showNoty(SUCCESS, "La notificación ha sido enviada.")
        this.onClose(SUCCESS)
      },
      (e)=>{
        this.setState({sendingNoty:false})
        if(!(e&&e.status&&e.status==401)){
          Util.showNoty(ERROR, "No se pudo enviar la notificación.")
        }
        console.log("ERROR AL ENVIAR NOTIFICACION A UN USUARIO", e)
          
      }
    )    
  }

  onClose(SUCCESS){
    this.props.initialize()
    this.props.onClose(SUCCESS)
  }

  render(){
    const {theme, open, user, handleSubmit} = this.props
    return (
      <Dialog open={open}>
        <DialogTitle>
          <Typography variant="h1" color="primary">Enviar Notificación a {user&&user.proName} {user&&user.proLastName}</Typography>
        </DialogTitle>
        <DialogContent style={{minWidth:500}}>
          <form> 
              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="title"
                  label="Título"
                  fullWidth
                  validate={[required]}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="body"
                  label="Descripción"
                  fullWidth
                  multiline
                  rows={4}
                  validate={[required]}

                />
              </Grid>
              <Grid item xs={12}>
                <ImageSelector
                  fieldName="image"
                  fileDimentions={{ width: 750, height: 370 }}
                  styleButton={theme.imageSelector}
                  // imagePreviewUrl={this.state.imgEdit}
                  // fileName={this.state.imgNameEdit}
                  fileSize={300000}
                  showDelete={true}
                  noPreview
                />
              </Grid>
          </form>
        </DialogContent>
        {this.state.sendingNoty?
          <CircularProgress style={{margin:30, alignSelf:"center"}}/>
              :
          <DialogActions>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" onClick={this.onClose}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Enviar">
              <Button variant="contained" color="primary" onClick={handleSubmit(this.onSend)}>Enviar</Button>
            </Tooltip>
          </DialogActions>
        }
      </Dialog>
    )
  }
}

// function mapStateToProps(store) {
//   return {
    
//   };
// }

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSendNotification
    },
    dispatch
  );
}

export default  reduxForm({
  form: "notifyUser",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(
    withTheme(
      connect(
        null,
        mapDispatchToProps
      )(NotifyUser)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/users/NotifyUser.js